import { server } from '../../core/engine/server'
import { modal } from '../../core/utilities/modal'

var ReportsHandler = Class.create({
  	initialize: function() {},
    getReport: function(reportType, start, end, property_id, callback) {
        if (property_id != 0) {
		    var url = "reports/" + reportType + "?start_date=" + start + "&end_date=" + end + "&property_id=" + property_id;
        } else {
            var url = "reports/" + reportType + "?start_date=" + start + "&end_date=" + end;
        }
        var data = server.getData(url,null,true);
        data.done(function(response) {
            if(response) {
                callback(response.data);
            } else {
                modal.showInfo("Unable to generate report", "warning", "top", "center");
            }
        })
        .fail(function(e){
            modal.resetBackDrop();
            modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
        });
        // if(reportType == 'property_leases_ending_60_days') {
        //   var data = {
        //     data: [{
        //       lease: '501',
        //       tenant: 'Frank Sam',
        //       property: '405 Ave Dr.',
        //       expires: 'August 31st, 2020'
        //     }],
        //     columns: ['Lease', 'Tenant', 'Property', 'Expires'],
        //     last_run: ''
        //   };
        // } else if (reportType == 'property_delinquent_tenants') {
        //   var data = {
        //     data: [{
        //       lease: '501',
        //       tenant: 'Karl Smith',
        //       last_payment: 'July 1st, 2020',
        //       amount_owed: '$1,456'
        //     }],
        //     columns: ['Lease', 'Tenant', 'Last Payment', 'Amount Owed'],
        //     last_run: ''
        //   };
        // } else if (reportType == 'owner_management_fees_collected') {
        //   var data = {
        //     data: [{
        //       owner: 'Property Group, LLC',
        //       fees_collected: '$5,768',
        //       last_collected: 'August 1st, 2020',
        //     }, {
        //       owner: 'Sharp Buildings, LLC',
        //       fees_collected: '$15,768',
        //       last_collected: 'July 1st, 2020',
        //     }],
        //     columns: ['Owner', 'Fees Collected', 'Last Collected'],
        //     last_run: ''
        //   };
        // } else if (reportType == 'owner_month_rent_paid') {
        //   var data = {
        //     data: [{
        //       owner: 'Property Group, LLC',
        //       property: '405 Smith Dr.',
        //       units: '10 units',
        //       current_collected: '$10,000',
        //       current_owed: '$1,350'
        //     }, {
        //       owner: 'Sharp Buildings, LLC',
        //       property: '10 North Dr.',
        //       units: '150 units',
        //       current_collected: '$120,000',
        //       current_owed: '$21,350'
        //     }],
        //     columns: ['Owner', 'Property', 'Units', 'Month Collected', 'Still Owed'],
        //     last_run: ''
        //   };
        // } else if (reportType == 'owner_profit_loss') {
        //   var data = {
        //     data: [{
        //       owner: 'Property Group, LLC',
        //       property: '405 Smith Dr.',
        //       expenses: '$2,552.44',
        //       income: '$10,000',
        //       net_income: '$7,447.56'
        //     }, {
        //       owner: 'Sharp Buildings, LLC',
        //       property: '10 North Dr.',
        //       expenses: '$20,552',
        //       income: '$120,000',
        //       net_income: '$99,448'
        //     }],
        //     columns: ['Owner', 'Property', 'Expenses', 'Income', 'Net Income'],
        //     last_run: ''
        //   };
        // }
    },
    exportReport: function(reportType, start, end, property_id, callback) {
	  var url = "export/report/" + reportType;
      var data = server.getFile(url, {start_date: start, end_date: end, property_id: property_id}, true, function(success){
        if(success) {
            callback();
        } else {
            modal.showInfo("Oops! Failed to download pdf.", "danger", "top", "center");
        }
      });
    },
});

export let reportsHandler = new ReportsHandler();


// WEBPACK FOOTER //
// app/helpers/Reports/ReportsHandler.js